/* eslint react/prop-types: 0 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Downshift from 'downshift';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropUpIcon from '@material-ui/icons/ExpandLessRounded';
import ArrowDropDownIcon from '@material-ui/icons/ExpandMoreRounded';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withTheme } from '@material-ui/core/styles';
import HighlightText from 'components/HighlightText';

class DownshiftField extends PureComponent {

  constructor(props) {
    super(props);

    this.state = { ignoreFilter: false };
  }

  keyDown = (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
    }
  };

  render() {
    return (
      <>
        {this.props.dataLoading ?
          <TextField
            {...this.props.textFieldProps}
            value={this.props.initialInputValue}
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment variant="filled" position="end">
                  <CircularProgress size={20} />
                </InputAdornment>
              ),
            }}
          />
          :
          <Downshift
            defaultHighlightedIndex={0}
            initialHighlightedIndex={this.props.items.indexOf(this.props.initialItemSelected)}
            initialInputValue={this.props.initialInputValue || (this.props.initialItemSelected ? this.props.itemToString(this.props.initialItemSelected) : '')}
            initialSelectedItem={this.props.initialItemSelected}
            onChange={(item) => this.props.onSelected && this.props.onSelected(item)}
            onInputValueChange={(inputValue) => {
              this.state.ignoreFilter && this.setState({ ignoreFilter: false });
              this.props.onInputValueChange && this.props.onInputValueChange(inputValue);
            }}
            itemToString={this.props.itemToString}
            stateReducer={(state, changes) => {
              let changesApproved = changes;
              switch (changes.type) {
                case Downshift.stateChangeTypes.blurInput:
                case Downshift.stateChangeTypes.mouseUp:
                  if (this.props.allowNonListedItems) {
                    changesApproved = {
                      ...changes,
                      inputValue: state.inputValue,
                    };
                  } else {
                    changesApproved = {
                      ...changes,
                      ...(changes.inputValue === null ? {inputValue: ''} : undefined),
                    };
                  }
                  break;
                default:
                  changesApproved = changes;
              }
              return changesApproved;
            }}
            id={this.props.textFieldProps && this.props.textFieldProps.id}
          >
            {({ getInputProps, getItemProps, getMenuProps, isOpen, inputValue, highlightedIndex, toggleMenu, selectItemAtIndex }) => {
              const inputValueLowerCase = inputValue && inputValue.toLowerCase();
              const filteredItems = this.state.ignoreFilter ?
                this.props.items :
                this.props.items && this.props.items.filter((item) => !inputValue || this.props.itemToString(item).toLowerCase().includes(inputValueLowerCase));
              const { value, ...inputProps } = (this.props.textFieldProps && this.props.textFieldProps.InputProps) || {};
              return (
                <div
                  role="presentation"
                  onKeyDown={isOpen ? this.keyDown : undefined}
                >
                  <TextField
                    {...this.props.textFieldProps}
                    inputRef={(node) => { this.anchorEl = node; }}
                    InputProps={{
                      ...getInputProps({
                        autoFocus: this.props.autoFocus,
                        endAdornment: (
                          <InputAdornment variant="filled" position="end">
                            <IconButton
                              style ={{ padding: 0 }}
                              aria-label="toggle options"
                            >
                              {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                        ...inputProps,
                        onKeyDown: (event) => {
                          if (isOpen) {
                            if (event.key === 'Tab' || event.key === 'Enter') {
                              if (!highlightedIndex && this.props.initialItemSelected !== inputValue) {
                                selectItemAtIndex(0);
                                event.stopPropagation();
                              } else if (highlightedIndex) {
                                selectItemAtIndex(highlightedIndex);
                                event.stopPropagation();
                              }
                            }
                          }
                        },
                        onClick:() => {
                          this.setState({ ignoreFilter: true });
                          toggleMenu();
                        },
                      }),
                    }}
                  />

                  {isOpen && filteredItems && filteredItems.length > 0 &&
                  <Popper
                    open
                    anchorEl={this.anchorEl}
                    placement="bottom-start"
                    style={{ zIndex: this.props.theme.zIndex.modal }}
                  >
                    <div {...getMenuProps({}, { suppressRefError: true })}>
                      <Paper>
                        <MenuList
                          style={{
                            maxHeight: 320,
                            overflowY: 'auto',
                          }}
                        >
                          {filteredItems.map((item, index) => {
                            const itemString = this.props.itemToString(item);
                            return (
                              <MenuItem
                                {...getItemProps({
                                  index,
                                  key: this.props.itemKey(item),
                                  id: (this.props.indexId && `item_${index}`) || this.props.itemKey(item),
                                  item,
                                  selected: index === highlightedIndex,
                                })}
                              >
                                <HighlightText
                                  text={itemString}
                                  searchKeys={[inputValue]}
                                />
                              </MenuItem>
                            );
                          })}
                        </MenuList>
                      </Paper>
                    </div>
                  </Popper>
                  }
                </div>
              );
            }}

          </Downshift>
        }
      </>
    );
  }

}

DownshiftField.defaultProps = {
  itemToString: (item) => item,
  itemKey: (item) => item,
  indexId: false,
};

DownshiftField.propTypes = {
  items: PropTypes.array,
  initialItemSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  initialInputValue: PropTypes.string,
  onSelected: PropTypes.func,
  onInputValueChange: PropTypes.func,
  itemToString: PropTypes.func,
  itemKey: PropTypes.func,
  dataLoading: PropTypes.bool,
  allowNonListedItems: PropTypes.bool,
  lightWeight: PropTypes.bool,
  indexId: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

export default withTheme(DownshiftField);
